module.exports = __webpack_public_path__ + "img/venus.be5030ca.webp";